import { useDioxus } from '@/lib/wasm'

export function LoadingDocumentsCard() {
  const ref = useDioxus('mount_loading_documents_card')
  return <div ref={ref} className="contents" />
}
